import type { PaletteOptions } from '@mui/material/styles';

/**
 * Dark theme palette - the original default theme
 */
export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#00f2ea', // Electric Cyan
    light: '#22d3ee',
    dark: '#06b6d4',
    contrastText: '#0B1120',
  },
  secondary: {
    main: '#7c3aed', // Electric Violet
    light: '#a78bfa',
    dark: '#6d28d9',
    contrastText: '#ffffff',
  },
  background: {
    default: '#0B1120', // Deep Navy/Charcoal base
    paper: '#162033', // Slightly lighter charcoal for cards
  },
  text: {
    primary: '#E2E8F0', // Slate 200
    secondary: '#94A3B8', // Slate 400
  },
  divider: 'rgba(255, 255, 255, 0.05)',
  action: {
    hover: 'rgba(255, 255, 255, 0.05)',
    selected: 'rgba(139, 92, 246, 0.2)',
    hoverOpacity: 0.05,
    selectedOpacity: 0.2,
  },
  error: {
    main: '#ef4444',
  },
  warning: {
    main: '#f59e0b',
  },
  info: {
    main: '#3b82f6',
  },
  success: {
    main: '#10b981',
  },
};
